/**
 * ProtectedRoute.tsx — 인증 필요 라우트 가드
 * - 비로그인 시 /login?redirect=<current> 이동
 * - 이메일 미인증 시 /verify-email (state.email 포함)
 * - 정상 인증 시 자식 렌더
 */
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuthStore } from '../store/authStore'

export default function ProtectedRoute() {
  const { isAuthenticated, user } = useAuthStore()
  const location = useLocation()

  // 1. 비로그인 — 현재 경로를 redirect 파라미터로 전달
  if (!isAuthenticated || !user) {
    return (
      <Navigate
        to={`/login?redirect=${encodeURIComponent(location.pathname + location.search)}`}
        replace
      />
    )
  }

  // 2. 이메일 인증 체크 — 백엔드 email_verified_at (ISO 문자열) 기준
  //    관리자(is_admin=true)는 CLI 로 부트스트랩된 경우 대비 통과
  const emailVerified = !!user.email_verified_at
  if (!emailVerified && !user.is_admin) {
    return (
      <Navigate
        to="/verify-email"
        replace
        state={{ email: user.email }}
      />
    )
  }

  return <Outlet />
}
